import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import _typeof from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import _defineProperty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.string.link";
import "core-js/modules/es6.regexp.match";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * 腾讯视频APP接口模块
 * @desc 该模块已废弃不维护，请使用 @tencent/vft-atom 调用
 */
import extend from 'lodash-es/extend';
import isArray from 'lodash-es/isArray';
import env from "./env";
import Storage from "./Storage/index";
import { getUserAgent, globalObject } from "./system";
import { createNormalizer } from "./urlFactory";
import util from "./util";
import Version from "./Version";
var urlNormalize = createNormalizer();
var ua = getUserAgent();
export var tenvideoReady = function tenvideoReady(fun) {
  if (!globalObject.document) return;

  fun = fun || function () {};

  if (typeof TenvideoJSBridge === 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('onTenvideoJSBridgeReady', fun, false);
    } else if (document.attachEvent) {
      document.attachEvent('onTenvideoJSBridgeReady', fun);
    }
  } else {
    fun();
  }
}; // 用普通的webview打开，多次返回会有关闭按钮。好莱坞的webview没有

export var openUrlCommonActivity = function openUrlCommonActivity(url) {
  return new Promise(function (resolve) {
    tenvideoReady(function () {
      var absUrl = _getAbsUrl(url);

      try {
        if (/^(http|https):\/\//.test(absUrl)) {
          absUrl = "txvideo://v.qq.com/Html5Activity?url=".concat(encodeURIComponent(absUrl));
        }

        TenvideoJSBridge.invoke('openView', {
          url: absUrl
        }, function () {
          resolve();
        });
      } catch (e) {
        location.href = url;
        resolve();
      }
    });
  });
};
export default {
  /**
   * 是否腾讯视频APP
   * @return {Boolean} [description]
   */
  isTenvideo: function isTenvideo() {
    return / QQLiveBrowser\//.test(ua) || / QQLiveHDBrowser\//.test(ua);
  },

  /**
   * 是否小企鹅APP
   * @return {Boolean} [description]
   */
  isKidApp: function isKidApp() {
    return / QQLiveKidBrowser\//.test(ua);
  },

  /**
   * 是否定制版APP
   * @return {Boolean} [description]
   */
  isOrderApp: function isOrderApp() {
    var that = this;
    return new Promise(function (resolve) {
      that.checkApi('getAppPayInfo').then(function (res) {
        resolve(res.getAppPayInfo);
      }, function () {
        resolve(false);
      });
    });
  },

  /**
   * 是否APP
   * @return {Boolean} [description]
   */
  isAllTenvideo: function isAllTenvideo() {
    return this.isTenvideo() || this.isKidApp();
  },

  /**
   * 判断APP是否支持新的JS API规范
   * @return {Boolean}
   */
  isNewAPI: function isNewAPI() {
    if (this.isTenvideo()) {
      var info = ua.match(/QQLive(HD)?Browser\/([\d.]+)/);

      if (info && info.length > 1) {
        var ver = info[2];

        if (env.isIos && ver >= '3.9' || ver >= '4.0') {
          return true;
        }

        return false;
      }

      return false;
    }

    if (this.isKidApp()) {
      return true;
    }

    return false;
  },

  /**
   * APP JS API Ready
   * @param  {Function} 回调方法
   * @return {[type]}
   */
  tenvideoReady: tenvideoReady,

  /**
   * 拉起登录
   * @param  {string} wx/qq
   * @param  {Function} 回调方法
   * @return {[type]}
   */
  openLogin: function openLogin(type, callback) {
    if (this.isNewAPI()) {
      type = type || 'tv';
      this.tenvideoReady(function () {
        TenvideoJSBridge.invoke('actionLogin', {
          type: type
        }, function (jsonMsg) {
          var json = JSON.parse(jsonMsg);

          if (parseInt(json.errCode, 10) === 0) {
            callback && callback(json.result);
          } else {
            callback && callback();
          }
        });
      });
    } else {
      if (env.isAndroid) {
        // Android登录
        var skey = Android.getCookieValue('skey');

        if (!!skey === false) {
          var id = window.setInterval(function () {
            skey = Android.getCookieValue('skey');

            if (skey) {
              window.clearInterval(id);
              var uin = Android.getCookieValue('uin');
              var lskey = Android.getCookieValue('lskey');
              skey = Android.getCookieValue('skey');
              callback && callback({
                state: 0,
                data: {
                  uin: uin,
                  skey: skey,
                  lskey: lskey
                }
              });
            }
          }, 500);
        } else {
          var uin = Android.getCookieValue('uin');
          var lskey = Android.getCookieValue('lskey');
          skey = Android.getCookieValue('skey');
          callback && callback({
            state: 0,
            data: {
              uin: uin,
              skey: skey,
              lskey: lskey
            }
          });
        }
      } else if (env.isIos) {
        _callIosBridge('logInQQ', null, function (jsonMsg) {
          callback && callback(jsonMsg);
        });
      }
    }
  },

  /**
   * 拉起登录
   * @param  {string} wx/qq
   * @param  {Function} 回调方法
   * @return {[type]}
   */
  logout: function logout(callback) {
    if (this.isNewAPI()) {
      this.tenvideoReady(function () {
        var param = {
          needBack: false
        };
        TenvideoJSBridge.invoke('logout', param, function (jsonMsg) {
          var json = JSON.parse(jsonMsg);

          if (parseInt(json.errCode, 10) === 0) {
            callback && callback();
          }
        });
      });
    }
  },
  openUrl: function openUrl(url, close) {
    var that = this;
    return new Promise(function (resolve) {
      that.tenvideoReady(function () {
        var absUrl = urlNormalize(_getAbsUrl(url), 'https:');

        try {
          if (env.isLiteApp) {
            if (/^(http|https):\/\//.test(absUrl)) {
              absUrl = "videolite://v.qq.com/H5HollywoodActivity?url=".concat(encodeURIComponent(absUrl));
            }

            TenvideoJSBridge.invoke('openView', {
              url: absUrl
            }, function () {
              resolve();
            });
            return;
          } // 坑爹的iphone 5.0.1之前的版本有url白名单限制，为了兼容处理，对于非qq域的h5页面用openUrl打开


          if (/^(http|https):\/\//.test(absUrl) && _getHost(absUrl).indexOf('qq.com') === -1) {
            TenvideoJSBridge.invoke('openUrl', {
              url: absUrl
            }, function () {
              resolve();
            });
            return;
          }

          if (/^(http|https):\/\/(film|pay)\.qq\.com/.test(absUrl)) {
            absUrl = "txvideo://v.qq.com/HollywoodH5Activity?url=".concat(encodeURIComponent(absUrl));
          } else {
            if (/^(http|https):\/\//.test(absUrl)) {
              absUrl = "txvideo://v.qq.com/Html5Activity?url=".concat(encodeURIComponent(absUrl));
            }
          }

          TenvideoJSBridge.invoke('openView', {
            url: absUrl,
            close: String(close || 0)
          }, function () {
            resolve();
          });
        } catch (e) {
          location.href = url;
          resolve();
        }
      });
    });
  },
  openUrlCommonActivity: openUrlCommonActivity,

  /**
   * 拉起QQ登录(旧方法已过时，请使用openLogin)
   * @param  {Function}
   * @return {[type]}
   */
  loginQQ: function loginQQ(callback) {
    this.openLogin('', callback);
  },

  /**
   * 设置分享
   * @param {[type]} 分享参数{title:'',desc:'',imgUrl:'',link:'',singleTitle: ''}
   */
  setShare: function setShare(param) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var title = param.title || '腾讯视频VIP影院';
    var desc = param.desc || '享受更好的，因为我是VIP';
    var pic = urlNormalize(param.imgUrl || '//puui.qpic.cn/vupload/0/1575447197802_m1krxk6ieeo.png/0', false);
    var url = urlNormalize(param.link || document.location.toString().replace(/[?&#](code|state|timestamp)=[^&#]+/gi, ''), false);
    var shareInfo = {
      title: title,
      subTitle: desc,
      imageUrl: pic,
      url: url
    };

    if (param.singleTitle) {
      shareInfo.singleTitle = param.singleTitle;
    }

    if (this.isNewAPI()) {
      this.tenvideoReady(function () {
        try {
          TenvideoJSBridge.invoke('setMoreInfo', _objectSpread({
            hasRefresh: true,
            hasShare: true,
            hasFollow: false,
            shareInfo: shareInfo
          }, options));
        } catch (err) {}
      });
    } else {
      if (env.isAndroid) {
        try {
          window.Android.isShowShareNotifyBar(1, 0);
          window.Android.goShare(title, pic, url);
        } catch (ex) {}
      } else {
        try {
          window.isWarn = 0;
          window.isShare = 1;
          window.shareTitle = title;
          window.shareSubTitle = desc;
          window.shareImageURL = pic;
          window.shareURL = url;
        } catch (ex) {}
      }
    }
  },
  setOnShareHandler: function setOnShareHandler(handler, cancelHandler) {
    this.tenvideoReady(function () {
      TenvideoJSBridge.on('onShareFinish', function (res) {
        var data;

        if (typeof res === 'string') {
          try {
            data = JSON.parse(res);
          } catch (e) {}
        } else if (_typeof(res) === 'object') {
          data = res;
        }

        if (data && parseInt(data.errCode, 10) === 0) {
          handler && handler();
        } else {
          cancelHandler && cancelHandler(data);
        }
      });
    });
  },

  /**
   * 设置分享图片
   */
  setShareImage: function setShareImage(imgUrl) {
    var title = '腾讯视频VIP影院';
    var desc = '享受更好的，因为我是VIP';
    var pic = urlNormalize(imgUrl, false);
    var url = urlNormalize(document.location.toString().replace(/[?&#](code|state|timestamp)=[^&#]+/gi, ''), false);

    if (this.isNewAPI()) {
      this.tenvideoReady(function () {
        try {
          TenvideoJSBridge.invoke('setMoreInfo', {
            hasRefresh: true,
            hasShare: true,
            hasFollow: false,
            isShareImageOnly: true,
            // 设置YES，可以分享图片，而不是H5
            shareInfo: {
              title: title,
              subTitle: desc,
              imageUrl: pic,
              url: url
            }
          });
        } catch (err) {}
      });
    } else {
      if (env.isAndroid) {
        try {
          window.Android.isShowShareNotifyBar(1, 0);
          window.Android.goShare(title, pic, url);
        } catch (ex) {}
      } else {
        try {
          window.isWarn = 0;
          window.isShare = 1;
          window.shareTitle = title;
          window.shareSubTitle = desc;
          window.shareImageURL = pic;
          window.shareURL = url;
        } catch (ex) {}
      }
    }
  },

  /**
   * 隐藏More菜单
   * @return {[type]} [description]
   */
  hideMore: function hideMore() {
    this.tenvideoReady(function () {
      try {
        TenvideoJSBridge.invoke('setMoreInfo', {
          hasRefresh: false,
          hasShare: false,
          hasFollow: false
        });
      } catch (err) {}
    });
  },

  /**
   * 显示More菜单
   */
  showMore: function showMore() {
    this.tenvideoReady(function () {
      try {
        TenvideoJSBridge.invoke('setMoreInfo', {
          hasRefresh: true,
          hasShare: true,
          hasFollow: true
        });
      } catch (err) {}
    });
  },

  /**
   * 判断是否安装腾讯视频APP
   * @param  {Function} 安装回调
   * @param  {Function} 未安装回调
   */
  isAppInstalled: function isAppInstalled(tCb, fCb) {
    if (ua.indexOf('MicroMessenger') >= 0) {
      var packageName = '';
      var packageUrl = '';

      if (env.isIos) {
        packageName = 'com.tencent.live4iphone';
        packageUrl = 'tenvideo2://can_open_me_if_install_and_regeister_this_scheme';
      } else if (env.isIpad) {
        packageName = 'com.tencent.QQLiveHD';
        packageUrl = 'tenvideohd://can_open_me_if_install_and_regeister_this_scheme';
      } else {
        // aphone
        packageName = 'com.tencent.qqlive';
        packageUrl = 'tenvideo://can_open_me_if_install_and_regeister_this_scheme';
      }

      setTimeout(function () {
        window.WeixinJSBridge && WeixinJSBridge.invoke('getInstallState', {
          packageName: packageName,
          packageUrl: packageUrl
        }, function (n) {
          var o = n.err_msg;

          if (o.indexOf('get_install_state:yes') > -1) {
            tCb && tCb();
          } else {
            fCb && fCb();
          }
        });
      }, 100);
    } else {
      util.loadScript('qqapi', '//pub.idqqimg.com/qqmobile/qqapi.js?_bid=152&max_age=31104000', function () {
        mqq.device.isMobileQQ(function (isQQ) {
          if (isQQ) {
            var name = '';

            if (env.isIos) {
              name = 'tenvideo2';
            } else if (env.isIpad) {
              name = 'tenvideohd';
            } else {
              name = 'com.tencent.qqlive';
            }

            mqq.app.isAppInstalled(name, function (isInstall) {
              var isInstallBoolean = typeof isInstall === 'boolean' && isInstall;
              var isInstallObject = _typeof(isInstall) === 'object' && isInstall && isInstall.result;

              if (isInstallBoolean || isInstallObject) {
                tCb && tCb();
              } else {
                fCb && fCb();
              }
            });
          } else {
            tCb && tCb();
          }
        });
      });
    }
  },

  /**
   * 获取当前主登录帐号的用户信息
   * @param suCb
   * @param failCb
   */
  getMainUserInfo: function getMainUserInfo(suCb, failCb) {
    this.tenvideoReady(function () {
      TenvideoJSBridge.invoke('getMainUserInfo', null, function (jsonMsg) {
        var json = JSON.parse(jsonMsg);

        if (parseInt(json.errCode, 10) === 0) {
          suCb && suCb(json.result);
        } else {
          failCb && failCb();
        }
      });
    });
  },

  /**
   * 打开分享窗口
   *【注：分享的参数需要事先调setMoreInfo设置好】
   * @return {[type]} [description]
   */
  openShare: function openShare() {
    this.tenvideoReady(function () {
      try {
        TenvideoJSBridge.invoke('openToolsDialog', null);
      } catch (err) {}
    });
  },

  /**
   * 拉起APP支付
   * @param  {[type]} param [description]
   * @return {[type]}       [description]
   */
  openPay: function openPay(param) {
    this.tenvideoReady(function () {
      try {
        var payType = 'openPay';

        if (param.product_type === 'day') {
          payType = 'openPayByDay';
        }

        TenvideoJSBridge.invoke(payType, param);
      } catch (err) {}
    });
  },

  /**
   * 拉起单点支付
   */
  openPaySingle: function openPaySingle(param, callback) {
    var appVer = this.getAppVersion();
    this.tenvideoReady(function () {
      try {
        if (appVer >= '5.2.1') {
          if (appVer === '5.2.1') {
            callback && callback({
              msg: 'refresh'
            });
          }

          TenvideoJSBridge.invoke('openPaySingle', param, function (res) {
            if (typeof res === 'string') {
              // 透传jsapi支付结果
              var json = JSON.parse(res);

              if (json && json.paySucc === 1) {
                callback && callback(extend({
                  msg: 'succ'
                }, json));
              } else {
                callback && callback(extend({
                  msg: 'payFailed'
                }, json));
              }
            }
          });
        } else {
          callback && callback({
            msg: 'download'
          });
        }
      } catch (e) {
        callback && callback({
          msg: 'tenvideoFailed'
        });
      }
    });
  },

  /**
   * 获取APP信息
   * @param  {Function} callback [description]
   * @return {[type]}            [description]
   */
  getAppInfo: function getAppInfo(callback) {
    var isCallback = false;
    var appInfo = Storage.getJSON('app_info');

    if (appInfo) {
      isCallback = true;
      callback && callback(appInfo);
    }

    this.tenvideoReady(function () {
      try {
        TenvideoJSBridge.invoke('getAppInfo', null, function (jsonMsg) {
          var json = JSON.parse(jsonMsg);

          if (parseInt(json.errCode, 10) === 0) {
            Storage.setJSON('app_info', json.result);
            !isCallback && callback && callback(json.result);
          } else {
            !isCallback && callback && callback();
          }
        });
      } catch (err) {}
    });
  },

  /**
   * 获取APP版本信息
   */
  getAppVersion: function getAppVersion() {
    var versionCode = '';

    if (this.isAllTenvideo()) {
      var posBrowser = ua.indexOf('QQLiveBrowser');

      if (this.isKidApp()) {
        posBrowser = ua.indexOf('QQLiveKidBrowser');
      }

      var tmp = ua.substring(posBrowser);
      var arrRtn = tmp.split('/');

      if (arrRtn.length >= 2) {
        var verTmp = arrRtn[1];
        var verTmpArr = verTmp.split('.');

        if (env.isAndroid) {
          if (verTmpArr.length >= 4) {
            versionCode = [verTmpArr[0], '.', verTmpArr[1], '.', verTmpArr[2]].join('');
          }
        } else {
          versionCode = verTmp;
        }
      }
    }

    return versionCode;
  },

  /**
   *@duplicate getAppVersion
   */
  getVersion: function getVersion() {
    if (!this.isAllTenvideo()) {
      return '';
    }

    var matches = ua.match(/(?:QQLiveBrowser|QQLiveKidBrowser|QQLiveHDBrowser)\/(\d+\.\d+\.\d+)/);
    return matches && matches.length >= 2 ? matches[1] : '';
  },

  /**
   * 切换帐号
   */
  switchLogin: function switchLogin(type, callback) {
    this.tenvideoReady(function () {
      try {
        TenvideoJSBridge.invoke('switchLoginState', {
          userType: type
        }, function () {
          TenvideoJSBridge.on('onSwitchLoginStateResponse', function (ret) {
            if (env.isIos) {
              ret = JSON.parse(ret);
            }

            if (ret && parseInt(ret.errCode, 10) === 0) {
              callback && callback();
            }
          });
        });
      } catch (err) {}
    });
  },
  isNewSdkVersion: function isNewSdkVersion() {
    var isNew = false;

    if (env.isIos && this.versionCompare(this.getAppVersion(), '4.5.5')) {
      isNew = true;
    } else if (env.isAndroid && this.versionCompare(this.getAppVersion(), '4.6.0')) {
      isNew = true;
    }

    return isNew;
  },

  /**
   * 版本号比较X.X.X
   */
  versionCompare: function versionCompare(version1, version2) {
    var v1Array = version1.split('.');
    var v2Array = version2.split('.');
    var result = false;

    if (v1Array.length === v2Array.length && v1Array.length > 2) {
      for (var i = 0; i < v1Array.length; i++) {
        var item1 = v1Array[i];
        var item2 = v2Array[i];
        var num1 = parseInt(item1, 10);
        var num2 = parseInt(item2, 10);

        if (num1 > num2) {
          result = true;
          break;
        } else if (num1 < num2) {
          result = false;
          break;
        } else {
          result = true;
        }
      }
    }

    return result;
  },

  /**
   * 获取定制版app信息
   */
  getAppPayInfo: function getAppPayInfo() {
    var that = this;
    return new Promise(function (resolve, reject) {
      that.tenvideoReady(function () {
        try {
          TenvideoJSBridge.invoke('getAppPayInfo', null, function () {
            resolve();
          });
        } catch (e) {
          reject(e);
        }
      });
    });
  },

  /**
   * 判断当前客户端版本是否支持指定JS接口
   */
  checkApi: function checkApi(api) {
    var that = this;
    var apiList = [];

    if (isArray(api)) {
      apiList = api;
    } else {
      apiList.push(api);
    }

    return new Promise(function (resolve, reject) {
      that.tenvideoReady(function () {
        try {
          TenvideoJSBridge.invoke('checkApi', {
            apiList: apiList
          }, function (res) {
            if (res && parseInt(res.errCode, 10) === 0) {
              resolve(res.result);
            } else {
              reject(res);
            }
          });
        } catch (e) {
          reject(e);
        }
      });
    });
  },

  /**
   * 刷新标题接口
   * @param title
   */
  refreshTitle: function refreshTitle(title) {
    this.tenvideoReady(function () {
      try {
        TenvideoJSBridge.invoke('refreshTitle', {
          title: title
        });
      } catch (err) {}
    });
  },

  /**
   *
   * @param base64 前端生成的图片base64
   * App 6.0.0及版本以上支持分享本地图片，6.0.0以下则采用先上传，拿到url后分享图片
   */
  shareLocalImage: function shareLocalImage(base64Str, callback) {
    var that = this;
    that.tenvideoReady(function () {
      try {
        if (that.canUseShareLocalImage()) {
          TenvideoJSBridge.invoke('shareLocalImage', {
            // 客户端要求去掉toDataUrl默认生成的base64头，传纯base64字符串即可
            imgbase64String: base64Str.replace(/^data:image\/(png|jpeg|webp);base64,/, '')
          }, function (jsonMsg) {
            var json = JSON.parse(jsonMsg);

            if (json && parseInt(json.errCode, 10) === 0) {
              callback && callback({
                msg: json.errMsg
              });
            } else {
              callback && callback({
                msg: 'tenvideoFailed'
              });
            }
          });
        } else {
          _uploadImage(base64Str, function (json) {
            if (json && parseInt(json.ret, 10) === 0 && json.result && json.result.access && json.result.access.length > 0) {
              var picUrl = "".concat(location.protocol, "//").concat(json.result.access[0]); // iOS代码实现有问题，要先调一下saveImage,不论是否成功，收到回调后再调分享图片

              if (env.isIos) {
                that.saveImage(picUrl, function () {
                  that.shareImageByUrl(picUrl, function (res) {
                    if (res && parseInt(res.errCode, 10) === 0) {
                      callback && callback({
                        msg: res.errMsg
                      });
                    } else {
                      callback && callback({
                        msg: 'tenvideoFailed'
                      });
                    }
                  });
                });
              } else {
                that.shareImageByUrl(picUrl, function (res) {
                  if (res && parseInt(res.errCode, 10) === 0) {
                    callback && callback({
                      msg: res.errMsg
                    });
                  } else {
                    callback && callback({
                      msg: 'tenvideoFailed'
                    });
                  }
                });
              }
            } else {
              callback && callback({
                msg: 'uploadImageFailed'
              });
            }
          });
        }
      } catch (e) {
        callback && callback({
          msg: 'tenvideoFailed'
        });
      }
    });
  },

  /**
   * hack app shareLocalImage
   */
  canUseShareLocalImage: function canUseShareLocalImage() {
    var version = new Version(this.getVersion());

    if (!version.compare('6.0.0')) {
      return false;
    }

    if (env.isIos) {
      return true;
    } // hack 安卓6.2.1-6.2.2版本分享bug


    if (version.compare('6.2.1') && !version.compare('6.2.3', false)) {
      return false;
    }

    return true;
  },

  /**
   * 通过图片url分享图片
   * @param picUrl
   * @param callback
   */
  shareImageByUrl: function shareImageByUrl(picUrl, callback) {
    this.tenvideoReady(function () {
      try {
        TenvideoJSBridge.invoke('shareLocalImage', {
          imageUrl: picUrl
        }, function (jsonData) {
          var json = JSON.parse(jsonData);

          if (json && parseInt(json.errCode, 10) === 0) {
            callback && callback(json);
          } else {
            callback && callback({
              msg: 'tenvideoFailed'
            });
          }
        });
      } catch (e) {
        callback && callback({
          msg: 'tenvideoFailed'
        });
      }
    });
  },

  /**
   * 保存图片到手机
   * @param picUrl
   * @param callback
   */
  saveImage: function saveImage(picUrl, callback) {
    this.tenvideoReady(function () {
      try {
        TenvideoJSBridge.invoke('saveImage', {
          url: picUrl
        }, function (jsonData) {
          var json = JSON.parse(jsonData);

          if (json && parseInt(json.errCode, 10) === 0) {
            callback && callback(json);
          } else {
            callback && callback({
              msg: 'tenvideoFailed'
            });
          }
        });
      } catch (e) {
        callback && callback({
          msg: 'tenvideoFailed'
        });
      }
    });
  }
};
/** @description 获取ios的接口
 * @param
  func_suc 获取到ios接口之后的回调函数
 @remark 首先判断ios接口是否存在，如果不存在的话，就监听下接口ready的事件，如果再5秒钟内两者都没有获取到接口，就提示失败
 */
// let iosBridgeDefer = null;

function _iosBridge(funcSuc) {
  funcSuc = funcSuc || function () {};

  if (typeof WebViewJavascriptBridge === 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('WebViewJavascriptBridgeReady', function () {
        WebViewJavascriptBridge.init();
        funcSuc();
      }, false);
    }
  } else {
    WebViewJavascriptBridge.init();
    funcSuc();
  }
}
/** @description 调用IOS的接口
 @param {str} str_method 所使用的接口的名字
 @param {str} str_param 输入的参数
 @param {str} func_suc 调用成功的回调函数
 */

/* eslint camelcase: ["off"] */


function _callIosBridge(str_method, str_param, func_suc) {
  _iosBridge(function () {
    WebViewJavascriptBridge.callHandler(str_method, str_param, function (str_msg) {
      var json_res = {};
      json_res = _parseJSON(str_msg);
      func_suc && func_suc({
        state: 0,
        origdata: str_msg,
        data: json_res
      });
    });
  });
}
/**
 * @descripton 解析JSON数据
 */


function _parseJSON(str_json) {
  var json_msg = null;

  try {
    json_msg = JSON.parse(str_json);
  } catch (e) {
    json_msg = null;
  }

  return json_msg;
}

function _getAbsUrl(url) {
  if (!/^(https:|http:)/.test(location.protocol) && /^\/\//.test(url)) {
    return "https:".concat(url);
  }

  var a = document.createElement('a');
  a.href = url;
  return a.href;
}

function _getHost(url) {
  var host = '';
  var oUrl;

  try {
    oUrl = new URL(url);
    host = oUrl.host;
  } catch (e) {// console.warn("[tenvideo._getHost]", e.message);
  }

  return host;
}
/**
 * 图片上传
 * @param base64
 * @private
 */


function _uploadImage(base64, callback) {
  $.ajax({
    url: "".concat(location.protocol, "//node.video.qq.com/x/services/imageupload"),
    type: 'POST',
    data: {
      base64: base64
    },
    // contentType: false,
    // processData: false,
    xhrFields: {
      withCredentials: true
    },
    success: function success(json) {
      callback && callback(json);
    }
  });
}